module.exports = __webpack_public_path__ + "static/img/message.995ed4d.png";


//////////////////
// WEBPACK FOOTER
// ./packages/assets/message.png
// module id = CjT1
// module chunks = 1